import {StateCreator} from 'zustand'

export interface IToastStore {
  successMessage: string
  errorMessage: string
  showSuccess: (message: string) => void
  showError: (message: string) => void
  resetToast: () => void
}

export const createToastSlice: StateCreator<
  IToastStore,
  [],
  [],
  IToastStore
> = set => ({
  successMessage: '',
  errorMessage: '',
  showSuccess: message => set({successMessage: message}),
  showError: message => set({errorMessage: message}),
  resetToast: () => set({successMessage: '', errorMessage: ''}),
})
